export default "__VITE_ASSET__CGGDb4Yl__"